import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts, MinMax } from "@saleor/types";
import { CouponStatusEnum } from "@saleor/types/globalTypes";

export enum CouponFilterKeys {}

export interface CouponListUrlFilterOpts {
  isFeatured: FilterOpts<boolean>;
  status: FilterOpts<CouponStatusEnum[]>;
  effectivityDates: FilterOpts<MinMax>;
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
}

export function createFilterStructure(): IFilter<undefined> {
  return [];
}
